import React from "react";
import { FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import theme from "./theme/theme1";
import { useSelector } from "react-redux";
import { useAuthSession } from "../../../../auth/useAuthSession";

export const InstitutionHeader = () => {
  const navigate = useNavigate();
  const company = useSelector((state) => state.companyReducer.company);
  const userDetail = useSelector((state) => state?.auth?.data) || {};
  const { isAuthenticated } = useAuthSession();
  const navigateToSignIn = () => {
    navigate("/sign-in");
  };

  const navigateToProfile = () => {
    navigate("/user-profile");
  };

  const headerStyle = {
    backgroundColor: theme.headerBg,
    height: "70px",
    fontFamily: theme.fontFamily,
    color: theme.linkText,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 1.5rem",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    marginBottom: 0,
  };

  const navStyle = {
    display: "flex",
    gap: "1rem",
  };

  const linkStyle = {
    color: theme.linkText,
    fontWeight: "600",
    textDecoration: "none",
    padding: "0.5rem 1rem",
    borderRadius: "8px",
    transition: "background-color 0.3s ease, color 0.3s ease",
  };

  const iconButtonStyle = {
    backgroundColor: theme.iconBg,
    color: theme.linkHoverText,
    borderRadius: "50%",
    padding: "0.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  };

  const handleMouseOver = (e) => {
    e.currentTarget.style.backgroundColor = theme.iconHoverBg;
  };

  const handleMouseOut = (e) => {
    e.currentTarget.style.backgroundColor = theme.iconBg;
  };

  // Check if user has primaryId
  const hasPrimaryId = userDetail?.primaryId;

  return (
    <header style={headerStyle}>
      {/* Logo */}
      <div>
        <img src={company?.logoLocation || ""} alt="Company Logo" style={{ height: "50px" }} />
      </div>

      {/* Navigation Links */}
      <nav style={navStyle}>
        {[{ text: "Home", to: "/" }, { text: "Admissions", to: "/online-application" },
        // { text: "Academics", to: "/academics" }, { text: "Fine Arts", to: "/fine-arts" },
        //  { text: "Alumni", to: "/alumni" },
        { text: "Contact Us", to: "/enquiry" }].map((link, index) => (
          <Link
            key={index}
            to={link.to}
            style={linkStyle}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = theme.linkBgHover;
              e.currentTarget.style.color = theme.linkHoverText;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = theme.linkText;
            }}
          >
            {link.text}
          </Link>
        ))}
      </nav>

      {/* Action Buttons */}
      <div style={{ display: "flex", gap: "1rem" }}>
        {isAuthenticated || hasPrimaryId ? (
          <div
            style={iconButtonStyle}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            onClick={navigateToProfile} // Navigate to profile page when user icon is clicked
          >
            <FaUser />
          </div>
        ) : (
          <button
            onClick={navigateToSignIn}
            style={{
              backgroundColor: theme.buttonBg,
              color: theme.buttonText,
              padding: "0.5rem 1rem",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              fontWeight: "bold", // Bold text
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = theme.buttonHoverBg;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = theme.buttonBg;
            }}
          >
            Sign In
          </button>
        )}
      </div>
    </header>
  );
};

export default InstitutionHeader;
